import { DIFFICULTY_CURVE } from '../constants';
import type { DifficultyParams } from '../types';

type CurveMap = Record<number, number>;

function interpolate(curve: CurveMap, time: number): number {
  const keys = Object.keys(curve).map(Number).sort((a, b) => a - b);

  if (time <= keys[0]) return curve[keys[0]];
  if (time >= keys[keys.length - 1]) return curve[keys[keys.length - 1]];

  for (let i = 0; i < keys.length - 1; i++) {
    if (time >= keys[i] && time <= keys[i + 1]) {
      const t = (time - keys[i]) / (keys[i + 1] - keys[i]);
      return curve[keys[i]] + t * (curve[keys[i + 1]] - curve[keys[i]]);
    }
  }

  return curve[keys[keys.length - 1]];
}

export class DifficultySystem {
  static getDifficulty(time: number): DifficultyParams {
    return {
      taskSpawnInterval: interpolate(DIFFICULTY_CURVE.taskSpawnInterval as unknown as CurveMap, time),
      agentDriftSpeed: interpolate(DIFFICULTY_CURVE.agentDriftSpeed as unknown as CurveMap, time),
      errorSubtlety: interpolate(DIFFICULTY_CURVE.errorSubtlety as unknown as CurveMap, time),
      taskComplexity: Math.floor(interpolate(DIFFICULTY_CURVE.taskComplexity as unknown as CurveMap, time)),
      queueMaxSize: Math.floor(interpolate(DIFFICULTY_CURVE.queueMaxSize as unknown as CurveMap, time)),
      taskTimeout: interpolate(DIFFICULTY_CURVE.taskTimeout as unknown as CurveMap, time),
      priorityChance: interpolate(DIFFICULTY_CURVE.priorityChance as unknown as CurveMap, time),
      correctionCooldown: interpolate(DIFFICULTY_CURVE.correctionCooldown as unknown as CurveMap, time),
      agentSpawnCost: Math.floor(interpolate(DIFFICULTY_CURVE.agentSpawnCost as unknown as CurveMap, time)),
    };
  }
}
